import styled from '@emotion/styled'
import { mq } from '../../../helpers'

export const OnSetServicesWrapper = styled.div`
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items: center;

    .hero-component {

      .hero-container-inner {
        ${mq('max', '768px')} {
          height: unset !important;
          height: auto !important;
        }

        .image-placeholder {
          overflow: hidden;

          ${mq('max', '768px')} {
            overflow: unset;
            overflow: hidden;
          }
          img {
            transform: translate(55px, 66px) scale(1.3);

            ${mq('max', '768px')} {
              transform: unset;
              transform: translate(40px, 50px) scale(1.2);
            }
          }
        }
      }

      .web-header-text {
        ${mq('max', '768px')} {
          display: none;
        }
      }

      .content {
        width: 100%;

        .inner {
          width: 100%;
        }

        button {
          ${mq('max', '768px')} {
            font-size: 16px;
          }
        }

        p {
          max-width: 80%;

          ${mq('max', '940px')} {
            max-width: unset;
            font-size: 20px;  
            margin-bottom: 24px;
          }
        }

        h1 {
          text-wrap: nowrap;

          ${mq('max', '1200px')} {
            text-wrap: unset;
          }

          ${mq('max', '940px')} {
            font-size: 46px;
          }

          ${mq('max', '821px')} {
            text-wrap: nowrap;
            font-size: 42px;
          }
        }
      }
    
      .mobile-header-text {
        display: none;
    
        ${mq('max', '768px')} {
          display: block;
          width: 100% !important;
        }
      }

      .image-placeholder {
        ${mq('max', '768px')} {
          height: 500px !important;
        }
      }
    }

    .how-content {

      .italic-header-container {
        display: flex;
        justify-content: center;
        align-items: center;
        
        .italic {
          font-style: italic;
        }
      }


      ${mq('max', '768px')} {
        h2 {
          text-align: left;
          max-width: 75%;
        }
      }

      .get-in-touch-text {
        ${mq('max', '768px')} {
          text-align: left;
          max-width: 80%
        }
      }

      .get-in-touch-button {
        margin-top: 68px;
        width: 100%;
        display: flex;
        justify-content: center;

        ${mq('max', '768px')} {
          justify-content: flex-start;
        }
      }
    }

`